<template lang="pug">
  div(class="m-block-new-feature")
    div(class="m-block-new-feature__image")
      v-img(
        v-if="image"
        :src="image"
        max-width="100%"
      )
    div(class="m-block-new-feature__content")
      h2(
        v-if="title"
        class="title-32px fw-700 mb-2"
      ) {{ title }}
      div(
        v-if="subtitle"
        class="text-14px mb-6 fw-300"
      ) {{ subtitle }}
      div(
        v-for="(feature, idx) in features"
        :key="idx"
        class="m-block-new-feature__feature"
      )
        div(class="m-block-new-feature__feature-icon")
          img(:src="feature.icon")
        div
          div(class="text-14px dark mb-1") {{ feature.title }}
          div(class="text-12px fw-300 m-block-new-feature__feature-description") {{ feature.description }}
    div(class="m-block-new-feature__footer")
      v-btn(
        height="48"
        @click="close"
      ) {{ $t('Skip') }}
      v-btn(
        class="main-button"
        @click="onButtonClick"
      ) {{ buttonText }}
</template>

<script>
export default {
  name: 'MBlockNewFeature',
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    image: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    features: {
      type: Array,
      default: () => []
    },
    buttonText: {
      type: String,
      default: null
    },
    onButtonClick: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    close() {
      this.onClose()
      this.closeModal()
    }
  }
}
</script>

<style scoped lang="scss">
.m-block-new-feature {
  &__image {
    width: 100%;
    height: 200px;
    background: linear-gradient(91deg, #fff -29.58%, #f8e3f4 66.15%);
    position: relative;

    display: flex;
    justify-content: center;
    align-items: flex-end;
  }

  &__content {
    padding: 32px 40px 32px 40px;
  }

  &__feature {
    display: grid;
    grid-template-columns: 48px 1fr;
    align-items: center;
    gap: 16px;

    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }

  &__feature-icon {
    width: 100%;
    height: 48px;
    border-radius: 50%;

    background-color: $background-gray;

    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 24px;
      height: auto;
    }
  }

  &__feature-description {
    max-width: 460px;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;

    padding: 32px 40px;
    border-top: 1px solid $border-disabled;
  }
}
</style>
